module.exports = __webpack_public_path__ + "static/media/MasterCard2.3eab6e0b.png";